import { useQuery } from "@tanstack/react-query";
import { dropdownService } from "../api/services/dropdownService";

export const useScreenTagOptions = () => {
  const {
    data: screenTagOptions,
    isLoading: isScreenTagOptionsLoading,
    refetch: refetchScreenTagOptions,
  } = useQuery({
    queryKey: ["screenTagOptions"],
    queryFn: () => dropdownService.getScreenTagOptions(),
  });

  return {
    screenTagOptions: screenTagOptions || [],
    isScreenTagOptionsLoading,
    refetchScreenTagOptions,
  };
};
